export const services = {
	services: {
		title: "Services",
		description: "Available services",
		adSpaces: {
			title: "Ad Space Sales",
			subtitle: "Advertise on Released Apps",
			description: "You can place banner ads and more on over 20 personal development apps. Effective ad delivery tailored to each app's target audience.",
			viewDetails: "View Details",
		},
	},

	adSpaces: {
		title: "Ad Space Sales",
		subtitle: "Advertising Service for Released Apps",
		description: "You can place banner ads and more on over 20 personal development apps.",
		features: {
			title: "Service Features",
			items: [
				{
					title: "Diverse App Portfolio",
					description: "Ad placement available across various genres including shift management, bulletin board browsing, and AI-integrated apps",
				},
				{
					title: "Flexible Ad Placement",
					description: "We propose optimal ad placements including banner ads and interstitial ads based on each app",
				},
				{
					title: "Transparent Reporting",
					description: "Regular reports on page views and impressions provided",
				},
			],
		},
		stats: {
			title: "Monthly Page Views of Major Apps",
			note: "* Actual measured values as of January 2026",
		},
		contact: {
			title: "Contact",
			description: "For inquiries about advertising, please feel free to contact us at the email address below.",
			emailButton: "Contact via Email",
			note: "* We typically respond within 1-2 business days.",
		},
		backToServices: "Back to Services",
	},
} as const;
